import axios from 'axios';
import { store } from '../configureStore';
import { loadingStart, loadingStop } from '../actions/index';
import { normalizeError } from './responseAdapter';

const reqData = {
  method: 'GET',
  url: '',
  queryParams: {},
  formData: {},
  bodyParams: {},
  pathParams: [],
  data: {},
};

function makeHeaders() {
  return {
    'Content-Type': 'application/json',
  };
}
/*eslint-disable */
function makeHeaderWithToken(token) {
  const headers = {
    Authorization: `${'Bearer' + ' '}${token}`,
    'Content-Type': 'application/json',
  };
  const activeCompanyId = localStorage.getItem('active_company_id');
  if (activeCompanyId) {
    headers['X-Company-Id'] = activeCompanyId;
  }
  return headers;
}

export function defaultApi(URL, method, details, hideLoader) {
  const token = localStorage.getItem('access_token');

  const api = axios.create({
    baseURL: URL,
    headers: token ? makeHeaderWithToken(token) : makeHeaders(),
  });

  let requestDetails = { ...reqData };
  requestDetails.url = URL;
  requestDetails.method = method;
  requestDetails.data = details;

  return apiCall(api, requestDetails, hideLoader)
    .then((response) => response)
    .catch((error) => error);
}

async function apiCall(api, requestDetails, hideLoader) {
  !hideLoader && store.dispatch(loadingStart());
  let apiReturn = {
    response: undefined,
    error: undefined,
  };

  try {
    const data = await api(requestDetails);
    apiReturn = { ...apiReturn, response: data };
  } catch (error) {
    // Normalize the backend envelope into the legacy { status, message, data } shape
    // the sagas read off `error.data`.
    const normalized = normalizeError(error && error.response);
    // Membership revoked for the active company: switch to the fallback the backend
    // chose (reuses the account-switch saga: sets active_company_id + refetches /me).
    // Swallow the error so the originating saga no-ops instead of flashing a failure
    // toast — the background switch + /me refresh recovers the UI.
    if (
      normalized.status === 'switch-company' &&
      normalized.data &&
      normalized.data.companyId
    ) {
      store.dispatch({
        type: 'ACCOUNT_SWITCH',
        credentials: { company_id: normalized.data.companyId },
      });
    } else {
      apiReturn = { ...apiReturn, error: { data: normalized } };
    }
  }

  !hideLoader && store.dispatch(loadingStop());

  return apiReturn;
}
